(function () {
  function ready(fn) {
    if (document.readyState === "complete" || document.readyState === "interactive") return setTimeout(fn, 0);
    document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    const root = document.querySelector("[data-mkpro]");
    if (!root) return;

    const get = (name) => root.querySelector(`[data-mk="${name}"]`);

    const el = {
      type: get("type"),
      qty: get("qty"),
      w: get("w"),
      h: get("h"),
      frame: get("frame"),
      mesh: get("mesh"),
      country: get("country"),
      email: get("email"),
      notes: get("notes"),

      // ✅ NEW: separations (Grande taille)
      seps: get("seps"),
      sepsWrap: root.querySelector('[data-mk="sepsWrap"]'),

      add: get("add"),
      copy: get("copy"),
      clear: get("clear"),
      send: get("send"),

      quote: get("quote"),
      empty: get("empty"),
      quoteHint: get("quoteHint"),

      lines: get("lines"),
      sumQty: get("sumQty"),
      sumPack: get("sumPack"),
      volDisc: get("volDisc"),
      sumTotal: get("sumTotal"),
      sumBig: get("sumBig"),

      err: get("err"),
      ok: get("ok"),
    };

    // --- Prix publics (vos données) ---
    const PUBLIC_PRICES = {
      porte: {
        standards: {
          "70x210": 29.99, "80x210": 30.99, "90x210": 31.99,
          "100x210": 32.99, "110x210": 33.99, "120x210": 34.99
        },
        surmesure: { M: 49.99, L: 69.99, XL: 89.99 }
      },
      fenetre: {
        standards: { "50x50": 29.99, "60x60": 31.99, "90x90": 35.99 },
        surmesure: { M: 49.99, L: 69.99, XL: 89.99 }
      },
      grandetaille: {
        surmesure: { SM1: 99.99, SM2: 149.99, SM3: 199.99, SM4: 249.99, SM5: 399.99 }
      }
    };

    // ✅ NEW: separations options + step
    const SEPS_STEP_EUR = 5.0;
    const SEPS_LABEL = "Séparations (Grande taille)";
    const SEPS_OPTIONS = [
      { value: "1", text: "1 séparation / 2 pans" },
      { value: "2", text: "2 séparations / 3 pans" },
      { value: "3", text: "3 séparations / 4 pans" },
      { value: "4", text: "4 séparations / 5 pans" },
      { value: "5", text: "5 séparations / 6 pans et plus" }
    ];

    // --- Remises (PRO + volume, cap 20%) ---
    function proBaseDiscountPct(p) {
      if (p <= 36) return 20;
      if (p <= 55) return 22;
      if (p <= 75) return 24;
      if (p <= 95) return 26;
      if (p <= 155) return 27;
      if (p <= 255) return 27;
      return 30;
    }
    function volumeDiscountPct(q) {
      if (q >= 480) return 10;
      if (q >= 240) return 7;
      if (q >= 120) return 5;
      if (q >= 80) return 3;
      return 0;
    }
    const MAX_TOTAL_DISCOUNT_PCT = 38;

    // --- Packaging ---
    const MOQ = 40;
    const CARTONS_PER_PALLET = 6;

    function round2(n) { return Math.round(n * 100) / 100; }
    function money(n) {
      if (n == null || !isFinite(n)) return "—";
      try { return new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(n); }
      catch (e) { return round2(n).toFixed(2) + " €"; }
    }

    function showErr(msg) {
      el.ok.style.display = "none";
      el.err.style.display = "block";
      el.err.textContent = msg;
    }
    function showOk(msg) {
      el.err.style.display = "none";
      el.ok.style.display = "block";
      el.ok.textContent = msg;
    }
    function clearMsgs() {
      el.err.style.display = "none"; el.err.textContent = "";
      el.ok.style.display = "none"; el.ok.textContent = "";
    }

    function packagingAuto(qty) {
      const cartons = Math.ceil(qty / MOQ);
      const pallets = Math.floor(cartons / CARTONS_PER_PALLET);
      const remainingCartons = cartons % CARTONS_PER_PALLET;

      let label = `${cartons} carton(s)`;
      if (pallets > 0) {
        label = `${pallets} palette(s) + ${remainingCartons} carton(s)`;
        if (remainingCartons === 0) label = `${pallets} palette(s)`;
      }
      return { cartons, pallets, remainingCartons, label };
    }

    function categorize(type, w, h) {
      if (type === "porte") {
        const key = `${w}x${h}`;
        if (h === 210 && PUBLIC_PRICES.porte.standards[key] != null) return { cat: "STANDARD", key };
        if (w <= 150 && h <= 230) return { cat: "M" };
        if (w <= 200 && h <= 260) return { cat: "L" };
        return { cat: "XL" };
      }
      if (type === "fenetre") {
        const key = `${w}x${h}`;
        if (PUBLIC_PRICES.fenetre.standards[key] != null) return { cat: "STANDARD", key };
        if (w <= 100 && h <= 100) return { cat: "M" };
        if (w <= 200 && h <= 200) return { cat: "L" };
        return { cat: "XL" };
      }
      if (type === "grandetaille") {
        const m = Math.max(w, h);
        if (m < 300) return { cat: "SM1" };
        if (m < 400) return { cat: "SM2" };
        if (m < 500) return { cat: "SM3" };
        if (m < 600) return { cat: "SM4" };
        return { cat: "SM5" };
      }
      return { cat: "—" };
    }

    function getPublicUnitPrice(type, c) {
      if (type === "porte") {
        if (c.cat === "STANDARD") return PUBLIC_PRICES.porte.standards[c.key];
        return PUBLIC_PRICES.porte.surmesure[c.cat];
      }
      if (type === "fenetre") {
        if (c.cat === "STANDARD") return PUBLIC_PRICES.fenetre.standards[c.key];
        return PUBLIC_PRICES.fenetre.surmesure[c.cat];
      }
      if (type === "grandetaille") {
        return PUBLIC_PRICES.grandetaille.surmesure[c.cat];
      }
      return null;
    }

    // ✅ NEW: inject separations field if not present in HTML
    function ensureSepsUI() {
      if (el.seps && el.sepsWrap) return;

      // Try to insert after "type" field container
      const typeField = el.type ? el.type.closest(".mkpro__field") : null;
      const parent = typeField && typeField.parentElement ? typeField.parentElement : root;

      const wrap = document.createElement("div");
      wrap.setAttribute("data-mk", "sepsWrap");
      wrap.className = (typeField && typeField.className) ? typeField.className : "mkpro__field";
      wrap.style.display = "none";

      const lab = document.createElement("div");
      lab.className = "mkpro__label";
      lab.textContent = SEPS_LABEL;

      const select = document.createElement("select");
      select.setAttribute("data-mk", "seps");
      select.className = "mkpro__select";

      SEPS_OPTIONS.forEach((o) => {
        const opt = document.createElement("option");
        opt.value = o.value;
        opt.textContent = o.text;
        select.appendChild(opt);
      });

      wrap.appendChild(lab);
      wrap.appendChild(select);

      if (typeField && typeField.nextSibling) {
        parent.insertBefore(wrap, typeField.nextSibling);
      } else {
        parent.appendChild(wrap);
      }

      el.sepsWrap = wrap;
      el.seps = select;
    }

    ensureSepsUI();

    // ✅ NEW: show/hide separations based on type
    function refreshSepsVisibility() {
      const show = el.type && el.type.value === "grandetaille";
      if (el.sepsWrap) el.sepsWrap.style.display = show ? "" : "none";
      if (!show && el.seps) el.seps.value = "1";
    }
    if (el.type) el.type.addEventListener("change", refreshSepsVisibility);
    refreshSepsVisibility();

    // --- Devis (mini-panier) ---
    const STORAGE_KEY = "mkpro_quote_v1";
    let quoteLines = [];

    function loadQuote() {
      try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return;
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) quoteLines = parsed;
      } catch (e) {}
    }
    function saveQuote() {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(quoteLines)); } catch (e) {}
    }

    function computeCurrentLine() {
      clearMsgs();

      const type = el.type.value;

      let qty = parseInt(el.qty.value || String(MOQ), 10);
      if (!isFinite(qty) || qty < MOQ) qty = MOQ;
      el.qty.value = qty;

      const w = parseInt(el.w.value || "1", 10);
      const h = parseInt(el.h.value || "1", 10);
      if (!isFinite(w) || w <= 0 || !isFinite(h) || h <= 0) {
        showErr("Largeur / hauteur invalides.");
        return null;
      }

      const c = categorize(type, w, h);
      const catLabel = (c.cat === "STANDARD") ? `Standard (${c.key})` : c.cat;

      let publicUnit = getPublicUnitPrice(type, c);
      if (publicUnit == null) {
        showErr("Prix introuvable pour ces dimensions.");
        return null;
      }

      // ✅ NEW: separations applied ONLY for grandetaille (+5€ par niveau)
      let seps = 1;
      if (type === "grandetaille" && el.seps) {
        seps = parseInt(el.seps.value || "1", 10);
        if (!isFinite(seps) || seps < 1) seps = 1;
        if (seps > 5) seps = 5;

        const extraLevels = Math.max(0, seps - 1);
        publicUnit = round2(publicUnit + extraLevels * SEPS_STEP_EUR);
      }

      return {
        id: crypto && crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + "_" + Math.random().toString(16).slice(2),
        type,
        qty,
        w,
        h,
        catLabel,
        frame: el.frame.value,
        mesh: el.mesh.value,
        // ✅ NEW
        seps,
        country: (el.country.value || "").trim(),
        email: (el.email.value || "").trim(),
        notes: (el.notes.value || "").trim(),
        publicUnit
      };
    }

    // Volume discount = basé sur le total unités du devis (plus cohérent)
    function recalcQuote() {
      const totalQty = quoteLines.reduce((s, l) => s + (parseInt(l.qty, 10) || 0), 0);
      const volPct = volumeDiscountPct(totalQty);

      let sumTotal = 0;

      const computedLines = quoteLines.map((l) => {
        const basePct = proBaseDiscountPct(l.publicUnit);
        const discPct = Math.min(MAX_TOTAL_DISCOUNT_PCT, basePct + volPct);
        const unit = l.publicUnit * (1 - discPct / 100);
        const lineTotal = round2(unit * l.qty);
        sumTotal += lineTotal;

        return {
          ...l,
          discPct,
          discountedUnit: unit,
          lineTotal
        };
      });

      const pack = packagingAuto(totalQty);

      return {
        totalQty,
        volPct,
        pack,
        sumTotal: round2(sumTotal),
        lines: computedLines
      };
    }

    function typeLabel(t){
      if (t === "porte") return "Porte";
      if (t === "fenetre") return "Fenêtre";
      if (t === "grandetaille") return "Grande taille (aimants 15cm)";
      return t;
    }

    function renderQuote() {
      if (!quoteLines.length) {
        el.quote.style.display = "none";
        el.empty.style.display = "block";
        el.quoteHint.textContent = "Ajoutez une ligne pour commencer";
        return;
      }

      const q = recalcQuote();

      el.sumQty.textContent = String(q.totalQty);
      el.sumPack.textContent = q.pack.label;
      el.volDisc.textContent = `${q.volPct}%`;
      el.sumTotal.textContent = money(q.sumTotal);
      el.sumBig.textContent = money(q.sumTotal);

      el.lines.innerHTML = q.lines.map((l, idx) => {
        const sepsTxt = (l.type === "grandetaille") ? ` • Séparations: ${l.seps || 1}` : "";
        const title = `${typeLabel(l.type)} • ${l.w}×${l.h} • ${l.catLabel}${sepsTxt} • Cadre ${l.frame} / Maille ${l.mesh}`;
        return `
          <div class="mkpro__tRow" data-line="${l.id}">
            <div>${idx+1}. ${escapeHtml(title)}</div>
            <div class="mkpro__tNum">${l.qty}</div>
            <div class="mkpro__tNum">${escapeHtml(money(round2(l.discountedUnit)))}</div>
            <div class="mkpro__tNum">${escapeHtml(money(l.lineTotal))}</div>
            <div class="mkpro__tNum"><button class="mkpro__x" type="button" data-remove="${l.id}" aria-label="Supprimer">✕</button></div>
          </div>
        `;
      }).join("");

      el.empty.style.display = "none";
      el.quote.style.display = "block";
      el.quoteHint.textContent = "Devis en cours";
    }

    function escapeHtml(str){
      return String(str)
        .replaceAll("&","&amp;")
        .replaceAll("<","&lt;")
        .replaceAll(">","&gt;")
        .replaceAll('"',"&quot;")
        .replaceAll("'","&#039;");
    }

    function buildQuoteSummary() {
      const q = recalcQuote();

      const lines = [];
      lines.push(`DEMANDE DEVIS PRO - MOSKILL`);
      lines.push(`Pays de livraison : ${(el.country.value || "").trim()}`);
      lines.push(`Total unités : ${q.totalQty}`);
      lines.push(`Conditionnement : ${q.pack.label}`);
      lines.push(`Remise volume (devis) : ${q.volPct}%`);
      lines.push(`Total estimé : ${money(q.sumTotal)}`);
      lines.push(``);
      lines.push(`DÉTAIL DES LIGNES :`);

      q.lines.forEach((l, i) => {
        const sepsInfo = (l.type === "grandetaille") ? ` | Séparations: ${l.seps || 1}` : "";
        lines.push(
          `${i+1}) ${typeLabel(l.type)} | ${l.w}x${l.h} cm | ${l.catLabel}${sepsInfo} | Cadre ${l.frame} / Maille ${l.mesh} | Qté ${l.qty} | PU ${money(round2(l.discountedUnit))} | Total ${money(l.lineTotal)}`
        );
      });

      const notes = (el.notes.value || "").trim();
      if (notes) {
        lines.push(``);
        lines.push(`COMMENTAIRES TECHNIQUES :`);
        lines.push(notes);
      }

      return lines.join("\n");
    }

    // --- Actions ---
    loadQuote();
    renderQuote();

    el.add.addEventListener("click", function () {
      const line = computeCurrentLine();
      if (!line) return;

      quoteLines.push(line);
      saveQuote();
      renderQuote();

      showOk("Ligne ajoutée au devis ✅");
    });

    el.clear.addEventListener("click", function(){
      quoteLines = [];
      saveQuote();
      renderQuote();
      showOk("Devis vidé ✅");
    });

    root.addEventListener("click", function(e){
      const btn = e.target && e.target.closest ? e.target.closest("[data-remove]") : null;
      if (!btn) return;
      const id = btn.getAttribute("data-remove");
      quoteLines = quoteLines.filter(l => l.id !== id);
      saveQuote();
      renderQuote();
      showOk("Ligne supprimée ✅");
    });

    el.copy.addEventListener("click", function () {
      if (!quoteLines.length) { showErr("Aucune ligne dans le devis."); return; }
      const txt = buildQuoteSummary();
      navigator.clipboard.writeText(txt).then(() => showOk("Devis copié ✅"));
    });

    el.send.addEventListener("click", async function () {
      if (!quoteLines.length) { showErr("Aucune ligne dans le devis."); return; }

      const email = (el.email.value || "").trim();
      if (!email || !email.includes("@")) {
        showErr("Veuillez renseigner un email professionnel valide.");
        el.email.focus();
        return;
      }

      const body = buildQuoteSummary();

      const form = new FormData();
      form.append("form_type", "contact");
      form.append("utf8", "✓");
      form.append("contact[email]", email);
      form.append("contact[body]", body);

      // Soumission via formulaire Shopify natif (ultra fiable)
      const formEl = root.querySelector("#MkProHiddenContact");

      formEl.querySelector('[name="contact[email]"]').value = email;
      formEl.querySelector('[name="contact[body]"]').value = body;

      // IMPORTANT: protection CAPTCHA Shopify
      if (window.Shopify && Shopify.captcha && typeof Shopify.captcha.protect === "function") {
        Shopify.captcha.protect(formEl, () => formEl.submit());
      } else {
        formEl.submit();
      }

      showOk("Demande envoyée avec succès ✅");
    });
  });
})();